import SimpleSchema from 'simpl-schema';

export default {
  _id: {
    type: Number,
    visibility: false
  },
  name: {
    label: 'Nombre',
    type: String
  },
  phone: {
    label: 'Teléfono',
    type: String
  },
  photo: {
    label: 'Foto <strong style="font-size: 14px;">max(1920x1080px)</strong>',
    type: SimpleSchema.Any,
    optional: true,
    image: true,
    maxWidth: 1920,
    maxHeight: 1080,
  },
};
